export default {
	"location": "มาเจอกันที่",
	"contact": "ติดต่อเรา",
	"openHour": "เวลาทำการ"
}
